export default "__VITE_ASSET__RzKirJ$L__";